// Display labels for injury domain constants — kept in sync with backend
// /api/injuries/constants. We hardcode the *labels* here (UI strings) but
// fetch the actual allowed values list from the backend so a new entry
// added server-side appears automatically.

export const SEVERITY_LABEL = {
  trivial: "Trivial",
  rest_needed: "Rest needed",
  see_doctor: "See doctor",
};

export const SEVERITY_COLOR = {
  trivial: "#10B981",
  rest_needed: "#F59E0B",
  see_doctor: "#EF4444",
};

export const STATUS_LABEL = {
  active: "Active",
  recovering: "Recovering",
  resolved: "Resolved",
};

export const STATUS_COLOR = {
  active: "#EF4444",
  recovering: "#F59E0B",
  resolved: "#10B981",
};

const TYPE_LABEL = {
  cut: "Cut",
  bruise: "Bruise",
  scrape: "Scrape",
  sprain: "Sprain",
  strain: "Strain",
  headache: "Headache",
  fever: "Fever",
  stomach: "Stomach",
  skin: "Skin",
  blister: "Blister",
  back_pain: "Back pain",
  other: "Other",
};

const BODY_PART_LABEL = {
  head: "Head",
  eye: "Eye",
  ear: "Ear",
  neck: "Neck",
  shoulder_l: "Shoulder (L)",
  shoulder_r: "Shoulder (R)",
  elbow_l: "Elbow (L)",
  elbow_r: "Elbow (R)",
  wrist_l: "Wrist (L)",
  wrist_r: "Wrist (R)",
  hand_l: "Hand (L)",
  hand_r: "Hand (R)",
  chest: "Chest",
  back_upper: "Upper back",
  back_lower: "Lower back",
  hip_l: "Hip (L)",
  hip_r: "Hip (R)",
  knee_l: "Knee (L)",
  knee_r: "Knee (R)",
  ankle_l: "Ankle (L)",
  ankle_r: "Ankle (R)",
  foot_l: "Foot (L)",
  foot_r: "Foot (R)",
  skin: "Skin (general)",
  stomach: "Stomach",
  general: "General / Other",
};

// Title-case fallback for any backend key we haven't mapped (so adding a new
// type server-side never produces an ugly snake_case label in the UI).
function titleCase(s) {
  if (!s) return "—";
  return s
    .replace(/_/g, " ")
    .replace(/\b\w/g, (m) => m.toUpperCase());
}

export function typeLabel(key) {
  return TYPE_LABEL[key] || titleCase(key);
}

export function bodyPartLabel(key) {
  return BODY_PART_LABEL[key] || titleCase(key);
}
